import React from 'react'
// components
import TableField from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/components/TableField'
import RiskTableContainer from 'containers/Risks/RiskTable'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// types
import { FieldType } from 'types/graphql'
// utils
import { orderBy } from 'lodash'

interface Props {
  parentFieldId?: string
}

const FieldsGroup: React.FC<Props> = ({ parentFieldId }) => {
  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const subFields = orderBy(
    riskTemplate.fields.filter(
      (item) =>
        item.fieldType !== FieldType.Label &&
        (parentFieldId ? item.parentFieldId === parentFieldId : !item.parentFieldId)
    ),
    'position'
  )

  if (!subFields.length) {
    return null
  }

  return (
    <>
      {subFields.map((field) => {
        if (field.fieldType === FieldType.Table) {
          const subFields = orderBy(
            riskTemplate.fields.filter(({ parentFieldId }) => parentFieldId === field.id),
            'position'
          )

          return subFields.length ? <RiskTableContainer key={field.id} field={field} fields={subFields} /> : null
        }

        if (field.fieldType === FieldType.Section) {
          return <FieldsGroup key={field.id} parentFieldId={field.id} />
        }

        return <TableField key={field.id} field={field} />
      })}
    </>
  )
}

export default FieldsGroup
